/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { FindAllSourceTags200ResponseDataInner } from './FindAllSourceTags200ResponseDataInner';
import {
    FindAllSourceTags200ResponseDataInnerFromJSON,
    FindAllSourceTags200ResponseDataInnerFromJSONTyped,
    FindAllSourceTags200ResponseDataInnerToJSON,
    FindAllSourceTags200ResponseDataInnerToJSONTyped,
} from './FindAllSourceTags200ResponseDataInner';
import type { GetSourceMergePreview200ResponseDataSourceToMergeSourceContactsInner } from './GetSourceMergePreview200ResponseDataSourceToMergeSourceContactsInner';
import {
    GetSourceMergePreview200ResponseDataSourceToMergeSourceContactsInnerFromJSON,
    GetSourceMergePreview200ResponseDataSourceToMergeSourceContactsInnerFromJSONTyped,
    GetSourceMergePreview200ResponseDataSourceToMergeSourceContactsInnerToJSON,
    GetSourceMergePreview200ResponseDataSourceToMergeSourceContactsInnerToJSONTyped,
} from './GetSourceMergePreview200ResponseDataSourceToMergeSourceContactsInner';
import type { GetSourceMergePreview200ResponseDataSourceToMergeSourceMergedIntoSource } from './GetSourceMergePreview200ResponseDataSourceToMergeSourceMergedIntoSource';
import {
    GetSourceMergePreview200ResponseDataSourceToMergeSourceMergedIntoSourceFromJSON,
    GetSourceMergePreview200ResponseDataSourceToMergeSourceMergedIntoSourceFromJSONTyped,
    GetSourceMergePreview200ResponseDataSourceToMergeSourceMergedIntoSourceToJSON,
    GetSourceMergePreview200ResponseDataSourceToMergeSourceMergedIntoSourceToJSONTyped,
} from './GetSourceMergePreview200ResponseDataSourceToMergeSourceMergedIntoSource';

/**
 * 
 * @export
 * @interface GetSourceMergePreview200ResponseDataSourceToMergeSource
 */
export interface GetSourceMergePreview200ResponseDataSourceToMergeSource {
    /**
     * 
     */
    id?: string;
    /**
     * ID of the surviving source after a merge, or null if this source has not been merged.
     */
    readonly merged_into?: string | null;
    /**
     * Whether this source has been soft-deleted.
     */
    readonly is_deleted?: boolean;
    /**
     * 
     */
    merged_into_source?: GetSourceMergePreview200ResponseDataSourceToMergeSourceMergedIntoSource;
    /**
     * 
     */
    name: string;
    /**
     * 
     */
    location?: string | null;
    /**
     * 
     */
    contacts?: Array<GetSourceMergePreview200ResponseDataSourceToMergeSourceContactsInner>;
    /**
     * 
     */
    phone?: string | null;
    /**
     * 
     */
    npi_number?: string | null;
    /**
     * All fax numbers associated with this source.
     */
    fax_numbers?: Array<string>;
    /**
     * 
     */
    email?: string | null;
    /**
     * 
     */
    tag_id?: string | null;
    /**
     * 
     */
    type?: GetSourceMergePreview200ResponseDataSourceToMergeSourceTypeEnum;
    /**
     * 
     */
    tag?: FindAllSourceTags200ResponseDataInner;
}


/**
 * @export
 */
export const GetSourceMergePreview200ResponseDataSourceToMergeSourceTypeEnum = {
    Hospital: 'Hospital',
    HomeCare: 'Home Care',
    Hospice: 'Hospice',
    AssistedLiving: 'Assisted Living',
    Other: 'Other',
    SkilledNursingFacility: 'Skilled Nursing Facility',
    IndependentLiving: 'Independent Living',
    Physician: 'Physician',
    LongTermAcuteCare: 'Long-Term Acute Care',
    InpatientRehabFacility: 'Inpatient Rehab Facility',
} as const;
export type GetSourceMergePreview200ResponseDataSourceToMergeSourceTypeEnum = typeof GetSourceMergePreview200ResponseDataSourceToMergeSourceTypeEnum[keyof typeof GetSourceMergePreview200ResponseDataSourceToMergeSourceTypeEnum];


/**
 * Check if a given object implements the GetSourceMergePreview200ResponseDataSourceToMergeSource interface.
 */
export function instanceOfGetSourceMergePreview200ResponseDataSourceToMergeSource(value: object): value is GetSourceMergePreview200ResponseDataSourceToMergeSource {
    if (!('name' in value) || value['name'] === undefined) return false;
    return true;
}

export function GetSourceMergePreview200ResponseDataSourceToMergeSourceFromJSON(json: any): GetSourceMergePreview200ResponseDataSourceToMergeSource {
    return GetSourceMergePreview200ResponseDataSourceToMergeSourceFromJSONTyped(json, false);
}

export function GetSourceMergePreview200ResponseDataSourceToMergeSourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetSourceMergePreview200ResponseDataSourceToMergeSource {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'merged_into': json['merged_into'] === undefined ? undefined : json['merged_into'] === null ? null : json['merged_into'],
        'is_deleted': json['is_deleted'] == null ? undefined : json['is_deleted'],
        'merged_into_source': json['merged_into_source'] == null ? undefined : GetSourceMergePreview200ResponseDataSourceToMergeSourceMergedIntoSourceFromJSON(json['merged_into_source']),
        'name': json['name'],
        'location': json['location'] === undefined ? undefined : json['location'] === null ? null : json['location'],
        'contacts': json['contacts'] == null ? undefined : ((json['contacts'] as Array<any>).map(GetSourceMergePreview200ResponseDataSourceToMergeSourceContactsInnerFromJSON)),
        'phone': json['phone'] === undefined ? undefined : json['phone'] === null ? null : json['phone'],
        'npi_number': json['npi_number'] === undefined ? undefined : json['npi_number'] === null ? null : json['npi_number'],
        'fax_numbers': json['fax_numbers'] == null ? undefined : json['fax_numbers'],
        'email': json['email'] === undefined ? undefined : json['email'] === null ? null : json['email'],
        'tag_id': json['tag_id'] === undefined ? undefined : json['tag_id'] === null ? null : json['tag_id'],
        'type': json['type'] == null ? undefined : json['type'],
        'tag': json['tag'] == null ? undefined : FindAllSourceTags200ResponseDataInnerFromJSON(json['tag']),
    };
}

export function GetSourceMergePreview200ResponseDataSourceToMergeSourceToJSON(json: any): GetSourceMergePreview200ResponseDataSourceToMergeSource {
    return GetSourceMergePreview200ResponseDataSourceToMergeSourceToJSONTyped(json, false);
}

export function GetSourceMergePreview200ResponseDataSourceToMergeSourceToJSONTyped(value?: Omit<GetSourceMergePreview200ResponseDataSourceToMergeSource, 'merged_into'|'is_deleted'> | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'merged_into_source': GetSourceMergePreview200ResponseDataSourceToMergeSourceMergedIntoSourceToJSON(value['merged_into_source']),
        'name': value['name'],
        'location': value['location'],
        'contacts': value['contacts'] == null ? undefined : ((value['contacts'] as Array<any>).map(GetSourceMergePreview200ResponseDataSourceToMergeSourceContactsInnerToJSON)),
        'phone': value['phone'],
        'npi_number': value['npi_number'],
        'fax_numbers': value['fax_numbers'],
        'email': value['email'],
        'tag_id': value['tag_id'],
        'type': value['type'],
        'tag': FindAllSourceTags200ResponseDataInnerToJSON(value['tag']),
    };
}

